class RapooSearchDialog extends HTMLElement {
  constructor() {
    super();
    
    
    
    // 初始化状态
    this.isOpen = this.hasAttribute('open');
  }
  
  // 定义观察的属性
  static get observedAttributes() {
    return ['open'];
  }
  
  // 当属性变化时触发
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'open') {
      this.isOpen = newValue === 'true' || newValue === '';
      this._updateVisibility();
      this._focusInput();
    }
  }
  
  // 当组件连接到DOM时触发
  // 在connectedCallback方法中添加
  connectedCallback() {
    // 查找关闭按钮并添加事件监听
    this.closeButton = this.querySelector('[data-close]');
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this._handleClose.bind(this));
    }
    
    // 添加ESC键关闭功能
    document.addEventListener('keydown', this._handleKeyDown.bind(this));
    
    // 初始化可见性
    this._updateVisibility();

		// 给toggle设置点击事件
    const toggleElements = document.querySelectorAll('.rapoo-search-dialog-toggle');
    if (toggleElements) {
      toggleElements.forEach(toggleElement => {
        toggleElement.addEventListener('click', this.open.bind(this));
      });
    }
    
    // 添加趋势搜索项点击功能
    const trendingItems = this.querySelectorAll('.trending-searches-item');
    trendingItems.forEach(item => {
      item.addEventListener('click', () => {
        const input = this.querySelector('input[type="search"]');
				console.log("onclick trending", input);
        if (input) {
          input.value = item.textContent.trim();
					input.focus();
          // 这里可以添加搜索触发逻辑
          // input.dispatchEvent(new Event('input'));
          // input.dispatchEvent(new Event('search'));
        }
      });
    });
  }
  
  // 当组件从DOM移除时触发
  disconnectedCallback() {
    if (this.closeButton) {
      this.closeButton.removeEventListener('click', this._handleClose);
    }
    document.removeEventListener('keydown', this._handleKeyDown);
  }
  
  // 打开弹框
  open() {
    this.setAttribute('open', 'true');
    this.isOpen = true;
    this._updateVisibility();
    this._focusInput();
  }
  
  // 关闭弹框
  close() {
    this.removeAttribute('open');
    this.isOpen = false;
    this._updateVisibility();
  }
  
  // 切换弹框状态
  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }
  
  // 内部方法：更新可见性
  _updateVisibility() {
    if (this.isOpen) {
      document.body.style.overflow = 'hidden'; // 防止背景滚动
      this.style.display = 'block';
    } else {
      document.body.style.overflow = '';
      this.style.display = 'none';
    }
  }
  
  // 内部方法：聚焦输入框
  _focusInput() {
    const input = this.querySelector('input[type="text"]');
    if (input && this.isOpen) {
      setTimeout(() => {
        input.focus();
      }, 100);
    }
  }
  
  // 内部方法：处理关闭事件
  _handleClose() {
    this.close();
  }
  
  // 内部方法：处理键盘事件
  _handleKeyDown(e) {
    if (e.key === 'Escape' && this.isOpen) {
      this.close();
    }
  }
}

customElements.define("rapoo-search-dialog", RapooSearchDialog);
